import { createTheme } from "@mui/material/styles";

/**
 * MUI theme with extended breakpoints and app palette.
 * Primary color matches design system (orange) for consistent focus states.
 */
export const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#ED6C02",
      light: "#FF9800",
      dark: "#E65100",
  components: {
    MuiTab: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
      contrastText: "#FFFFFF",
    },
  },
  /* MUI built-in breakpoints (xs–xl) + app-specific. Used by responsiveStyles, sx, useMediaQuery. */
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      tablet: 768,
      tabletUp: 769,
      desktop: 1024,
      desktopUp: 1025,
      desktopMd: 1100,
      desktopLg: 1280,
      mobile: 720,
      mobileXs: 400,
      desktopSm: 960,
    },
  },
});
